import {
  EditScenarioParams,
  EmptyGenericScenarioParams,
  GenericInputParams,
  Opener,
  Orientations,
  Scenarios,
  Source,
  Templates,
  VideoScripts,
} from './withVideoMaker.types';

export type videoMakerLocale = GenericInputParams['locale'];

interface IVideoMakerOpenerParams {
  locale: videoMakerLocale;
  metaSiteId: string;
  origin: string;
  siteMediaToken: string;
  userId: string;
  extendedVideoMakerParams?: IExtendedVideoMakerParams;
}

export interface IExtendedVideoMakerParams {
  scenario?: Scenarios.Generic | Scenarios.Edit;
  videoData?: {
    sources: Source[];
  };
  fileId?: string;
}

export function initializeVideoMakerOpenerParams({
  locale,
  metaSiteId,
  origin,
  siteMediaToken,
  userId,
  extendedVideoMakerParams = {
    videoData: undefined,
    fileId: undefined,
  },
}: IVideoMakerOpenerParams): EmptyGenericScenarioParams | EditScenarioParams {
  const { videoData, fileId } = extendedVideoMakerParams;

  const initialData = {
    locale,
    metaSiteId,
    opener: Opener.MediaManager,
    origin,
    siteMediaToken,
    userId,
  };

  return fileId
    ? {
        ...initialData,
        scenario: Scenarios.Edit,
        fileId,
      }
    : {
        ...initialData,
        scenario: Scenarios.Generic,
        template: Templates.Empty,
        videoData: {
          business: {},
          themeId: '207', // edgy, list of themes https://pix.wix.com/services/video-maker/music/themes
          trackId: '21306', // list of tracks https://pix.wix.com/services/video-maker/music/tracks/all
          script: VideoScripts.GENERAL_TEMPLATE,
          scriptData: {},
          sources: [],
          orientation: Orientations.Landscape,
          ...videoData,
        },
      };
}
